document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-clipboardable]').forEach(function(el) {
    el.addEventListener("click", function(event) {
      event.preventDefault();
      // The element that carries the data, not event.target: a click on the
      // icon inside the link targets the icon, which carries nothing.
      navigator.clipboard.writeText(el.dataset.clipboardable);

      // A copy worth counting names its GA4 event (the embed code does).
      if (el.dataset.ga4Event && window.gtag) {
        window.gtag('event', el.dataset.ga4Event);
      }

      const selector = `#${el.id}`;
      $(selector).tooltip('enable');
      $(selector).tooltip('show');
      setTimeout(function () {
        $(selector).tooltip('disable');
      }, 1000)
    });
  });
});
